import { PageProps } from 'gatsby';
import React from 'react';
import { parse } from 'node-html-parser';

import '../styles/blog.css';
import { Seo } from '../components';
import useSiteMetadata from '../hooks/useSiteMetadata';

interface Props extends PageProps {
  pageContext: PageProps['pageContext'] & {
    title: string;
    fullDescription: string;
  };
}

const CustomPageTemplate: React.FC<Props> = ({ pageContext }) => {
  const { title, fullDescription } = pageContext;
  const { siteDescription } = useSiteMetadata();

  const pageContent = React.useMemo(
    () => (fullDescription ? parse(fullDescription).innerHTML : ''),
    [fullDescription]
  );

  return (
    <>
      <Seo title={title} description={siteDescription} />
      <section className="pt-10 bg-gray-100 pb-7 h-full">
        <div className="container">
          <h2 className="pb-4 md:pb-10 text-center">{title}</h2>
          <div
            className="w-full bg-white rounded-lg p-10 mb-7 markdown"
            dangerouslySetInnerHTML={{
              __html: pageContent,
            }}
          />
        </div>
      </section>
    </>
  );
};

export default CustomPageTemplate;
